// extracted by mini-css-extract-plugin
module.exports = {"menu":"Desktop_menu__tWJFa","item":"Desktop_item__XvAYE"};